import React, { useState } from "react"
import { ActivityIndicator, Alert, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Avatar } from "react-native-paper"
import CustomBorderedText from "@Components/CustomBorderedText/CustomBorderedText"
import { frenchDate, fullName } from "@Utils/utils"
import ReportMessageModal from "./ReportMessageModal"
import { MaterialIcons } from "@expo/vector-icons"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"

const CustomTopicContent = (props) => {
    const { isMessage, item, topicCategory, successfull, failed, toggleEdition, sending } = props
    const user = useRecoilValue(userAtom)
    const [isModalVisible, setModalVisible] = useState(false)
    const { owner, createdAt, content, id } = item
    const userName = fullName(owner.firstName, owner.lastName) ?? ""
    const postedAt = frenchDate(createdAt) ?? "---"
    const postContent = content ?? ""
    const toggleModal = () => setModalVisible((prev) => !prev)
    const [deleting, setDeleting] = useState(false)

    const handleDeleteMessage = () => {
        setDeleting(true)
        ForumService.deleteForumAnswer(id)
            .then(() => {
                successfull("Suppression avec succès.")
                setDeleting(false)
            })
            .catch(() => {
                failed()
                setDeleting(false)
            })
    }

    const confirmMessageDelete = () => {
        Alert.alert("Suppression message", "Voulez-vous vraiment supprimer votre message ?", [
            {
                text: "Annuler",
                onPress: () => {}
            },
            {
                text: "OUI",
                onPress: () => handleDeleteMessage()
            }
        ])
    }

    const isMyMessage = owner?.id === user?.id

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <View style={styles.leftContent}>
                    <Avatar.Text size={50} style={styles.avatar} label="AV" />
                    <View style={styles.userInfos}>
                        <OpenSansText
                            numberOfLines={2}
                            defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                            fontSize={RFValue(16)}
                        >
                            {userName ?? "---"}
                        </OpenSansText>
                        <OpenSansText
                            style={styles.createdDate}
                            defaultFontFamily={baseFontFamily.OpenSansRegular}
                            fontSize={RFValue(14)}
                        >
                            {postedAt ?? "---"}
                        </OpenSansText>
                    </View>
                </View>
                {isMyMessage && !sending && (
                    <View style={{ flexDirection: "row" }}>
                        {deleting ? (
                            <ActivityIndicator color={baseColors.orange.primary} size={25} />
                        ) : (
                            <>
                                <TouchableOpacity style={{ marginRight: 15 }} onPress={() => toggleEdition(item)}>
                                    <MaterialIcons name="edit" size={24} color={baseColors.green.primary} />
                                </TouchableOpacity>
                                <TouchableOpacity onPress={confirmMessageDelete}>
                                    <MaterialIcons name="delete" size={24} color={baseColors.orange.primary} />
                                </TouchableOpacity>
                            </>
                        )}
                    </View>
                )}
            </View>

            <View style={styles.content}>
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(14)}>
                    {postContent ?? "---"}
                </OpenSansText>
            </View>

            <View style={styles.footer}>
                <View>
                    {!isMessage && (
                        <CustomBorderedText
                            color={baseColors.orange.primary}
                            backgroundColor={baseColors.white}
                            label={topicCategory ?? "---"}
                        />
                    )}
                </View>
                {!isMyMessage && isMessage && !sending && (
                    <TouchableOpacity onPress={toggleModal}>
                        <OpenSansText
                            style={{ color: baseColors.green.primary }}
                            defaultFontFamily={baseFontFamily.OpenSansRegular}
                            fontSize={RFValue(16)}
                        >
                            Signaler
                        </OpenSansText>
                    </TouchableOpacity>
                )}
            </View>

            <ReportMessageModal messageId={id} isModalVisible={isModalVisible} toggleModal={toggleModal} />
        </View>
    )
}

export default CustomTopicContent
